import { MutationTree } from "vuex";
import { IRootState } from "./types";
import { actionNames } from "./actions";

export const mutations: MutationTree<IRootState> = {
  [actionNames.SET_ROUTE](state, payload: string) {
    state.currentRoute = payload;
  }
};
